/**
 * BUSINESS EMAIL ADDRESS API — CRUD degli email di un Business.
 *
 * Contratto backend (rest-openapi.yaml, BusinessesResourceImpl):
 *   POST   /business/{businessId}/emailAddress                 EmailAddressInput -> EmailAddress
 *   PATCH  /business/{businessId}/emailAddress/{emailAddressId} EmailAddressInput -> EmailAddress
 *   DELETE /business/{businessId}/emailAddress/{emailAddressId}                   -> 200
 *
 * Speculare a personEmailAddressApi.ts — stessa shape, solo path-owner
 * differente. Il thunk polimorfico emailAddressThunks.addEmailAddress
 * instrada in base a `className`:
 *   - 'Person'   -> personEmailAddressApi
 *   - 'Business' -> questo file
 *
 * Nota: il backend accetta opzionalmente `listTypeId`. Non lo esponiamo
 * in UI per ora (resta al default lato server).
 */

import { httpClient } from '../../api/httpClient';
import type { EmailAddress } from '../emailAddress/emailAddressTypes';

interface EmailAddressInput {
  address: string;
  primary: boolean;
  listTypeId?: number;
}

const NESTED = (businessId: number) => `/business/${businessId}/emailAddress`;

export const businessEmailAddressApi = {
  create: (businessId: number, payload: EmailAddressInput): Promise<EmailAddress> =>
    httpClient.post<EmailAddress>(NESTED(businessId), payload).then((r) => r.data),

  update: (
    businessId: number,
    emailAddressId: number,
    payload: EmailAddressInput
  ): Promise<EmailAddress> =>
    httpClient
      .patch<EmailAddress>(`${NESTED(businessId)}/${emailAddressId}`, payload)
      .then((r) => r.data),

  remove: (businessId: number, emailAddressId: number): Promise<void> =>
    httpClient.delete(`${NESTED(businessId)}/${emailAddressId}`).then(() => undefined),
};
